<ion-header translucent>
  <ion-toolbar color="subasta-header">
    <ion-buttons *ngIf="button" slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

    <ion-title class="header-title">
      <ion-row class="vertical ion-no-padding">
        <ion-col size="8">
          <ion-row>
            <ion-col size="12" class="font-title ion-no-padding">{{title}}</ion-col>
          </ion-row>
          <ion-row *ngIf="fechaCabecera">
            <ion-col size="12" class="font-medium ion-no-padding">{{ fechaCabecera | date: 'dd/MM/yy HH:mm:ss' }}
            </ion-col>
          </ion-row>
        </ion-col>
        <ion-col size="2" class="vertical" style="flex-direction: column;">
          <ion-row>
            <ion-col size="12" class="ion-no-padding">
              <fa-icon [icon]="faService.faWifi" (click)="changePingVisibility()" class="wifiSize defaultState"
                [ngClass]="{'greenState': mqttService.client?.connected , 'redState': mqttService.client?.reconnecting || mqttService.client?.disconnected || !mqttService.client , 'yellowState': mqttService.client?.connected && mqttService.timeDifference > 100 }"></fa-icon>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" class="ion-no-padding">
              <p *ngIf="showTimeDifference == true" class="msParrafo">{{mqttService.timeDifference}} ms</p>
            </ion-col>
          </ion-row>
        </ion-col>
        <ion-col size="2" class="verticalRight" [matMenuTriggerFor]="menu" style="flex-direction: column;">
          <ion-row>
            <ion-col size="12" class="ion-no-padding">
              <fa-icon [icon]="faService.faUser" class="person-icon"></fa-icon>
            </ion-col>
          </ion-row>
          <mat-menu #menu="matMenu" class="menusuperior">
            <div mat-menu-item class="vertical person-menu-option person-menu-header">
              <ion-label><b>{{user.username}}</b></ion-label>
            </div>
            <button mat-menu-item class="person-menu-option" (click)="cambioContrasenha();">
              <ion-grid>
                <ion-row>
                  <ion-col size="2" class="vertical">
                    <fa-icon [icon]="faService.faLock"></fa-icon>
                  </ion-col>
                  <ion-col size="10">
                    <ion-label class="tamanoLetra">Cambio contraseña</ion-label>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </button>
            <button mat-menu-item class="person-menu-option" (click)="closeApp();">
              <ion-grid>
                <ion-row>
                  <ion-col size="2" class="vertical">
                    <fa-icon [icon]="faService.faPowerOff"></fa-icon>
                  </ion-col>
                  <ion-col size="10">
                    <ion-label class="tamanoLetra">Cerrar sesión</ion-label>
                  </ion-col>
                </ion-row>
              </ion-grid>


            </button>
          </mat-menu>
        </ion-col>
      </ion-row>
    </ion-title>
  </ion-toolbar>
</ion-header>